import { defineStore } from 'pinia'
import AuthService from "@/services/auth.service";
import CompanyService from "@/services/company.service.ts";
export const useCompanyStore = defineStore('company', {
    state: () => {
        return {
            company: {},
            listCompanies: [],
            isRegister: false,
            lastFetched: null,
            CACHE_DURATION: 5 * 60 * 1000
        }
    },
    persist: true,
    actions: {
        async register(url, params) {
            try {
                const company = await AuthService.register(url, params)
                this.company = company.data.data
                this.isRegister = true
            } catch (e) {
                return e
            }
        },
        async getListCompanies(url, params) {
            const now = Date.now()
            const isCacheExpired =
                !this.lastFetched || now - this.lastFetched > this.CACHE_DURATION

            if (this.listCompanies.length > 0 && !isCacheExpired) {
                return this.listCompanies
            }
            try {
                const companies = await CompanyService.getListCompanies(url, params)
                this.listCompanies = companies.data
            } catch (e) {
                return null
            }
        },
    }
})
